module.exports = __webpack_public_path__ + "img/channel-1-icon.96669207.png";